import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { UpdateBoardTitle } from '..';

export function useUpdateBoardTitle() {
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return useMutation({
    mutationFn: ({ boardId, title }: { boardId: string; title: string }) =>
      UpdateBoardTitle(boardId, { title }),
    onSuccess: (_, { boardId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.board.all() });
      queryClient.invalidateQueries({ queryKey: queryKeys.board.detail(boardId) });
    },
  });
}
